import { Link } from 'react-router-dom';
import { ShieldCheckIcon } from '@heroicons/react/24/solid';

export default function Logo({ className = '', linkTo = '/' }) {
  return (
    <Link to={linkTo} className={`flex items-center gap-2 ${className}`}>
      <ShieldCheckIcon className="h-8 w-8 text-primary-600" />
      <span className="font-bold text-xl text-slate-900 dark:text-white">
        CyberActions
      </span>
    </Link>
  );
}
